import * as React from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

interface ThumbToggleButtonProps {
  onClick: (e: React.SyntheticEvent<HTMLButtonElement, MouseEvent>) => void;
  isToggled?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  ariaLabel: string;
}

const specialGrey = 'rgba(255, 255, 255, 0.1)';

const StyledButton = styled.button<{ isToggled?: boolean }>`
  font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
  height: 30px;
  padding: 0 ${tokens.spacer.x2};
  border-radius: 3px;
  border: 1px solid ${tokens.color.text_default_inverse};
  background: ${({ isToggled }) => (isToggled ? tokens.color.text_default_inverse : 'transparent')};
  color: ${({ isToggled }) =>
    isToggled ? tokens.color.text_default : tokens.color.text_default_inverse};
  font-weight: 400;
  font-size: 12px;
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${({ isToggled }) => (isToggled ? tokens.color.neutral_100 : specialGrey)};
  }

  &:active {
    background: ${({ isToggled }) =>
      isToggled ? 'transparent' : tokens.color.text_default_inverse};
    color: ${({ isToggled }) => (isToggled ? tokens.color.text_default_inverse : 'transparent')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    ${tokens.focus()};
  }
`;

export const ThumbToggleButton = ({
  onClick,
  isToggled,
  disabled,
  children,
  ariaLabel,
}: ThumbToggleButtonProps): JSX.Element => {
  return (
    <StyledButton
      type="button"
      isToggled={isToggled}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </StyledButton>
  );
};
